import React, { useState } from 'react';
import PageChrome from '../components/PageChrome';
import SsgStandings from './ssg/SsgStandings';
import SsgSessionsList from './ssg/SsgSessionsList';
import SsgSessionEditor from './ssg/SsgSessionEditor';
import SsgHallOfFame from './ssg/SsgHallOfFame';

// This app has no per-page URL routing (every top-level page lives under /app behind a single
// activePage switch — see App.js's PageContent) — "/ssg", "/ssg/sessions", "/ssg/session/:id" and
// "/ssg/hall-of-fame" are implemented as one page component's own internal state, the same
// pattern LineupBuilder and every other list-then-detail flow in this app already uses, not
// literal react-router paths.
// Wrapped in PageChrome (the Home/Team-table/Squad-builder shell) rather than AppShell's default
// header — 'ssg' is in App.js's hideHeader list so the two don't stack.
// "/ssg" itself (Stage 4) is the standings/league-table view — the default. Sessions
// list/editor (Stage 3) and Hall of Fame (Stage 7) are reached via links on the standings page.
export default function Ssg({ user, onNavigate }) {
  const [view, setView] = useState('standings'); // standings | sessions | hallOfFame
  const [openSessionId, setOpenSessionId] = useState(null);

  let content;
  if (openSessionId) {
    content = <SsgSessionEditor sessionId={openSessionId} user={user} onBack={() => setOpenSessionId(null)} />;
  } else if (view === 'sessions') {
    content = <SsgSessionsList user={user} onOpenSession={setOpenSessionId} onBackToStandings={() => setView('standings')} />;
  } else if (view === 'hallOfFame') {
    content = <SsgHallOfFame onBack={() => setView('standings')} />;
  } else {
    content = <SsgStandings user={user} onManageSessions={() => setView('sessions')} onOpenHallOfFame={() => setView('hallOfFame')} />;
  }

  return <PageChrome onNavigate={onNavigate} user={user}>{content}</PageChrome>;
}
